<template>
  <el-card class="box-card personal-info" v-loading="edit_loading">
    <el-row class="basic-info">
      <el-col>
        <el-form
          ref="basicForm"
          :model="user_info"
          :rules="basic_rules"
          label-width="180px"
          label-position="right"
          size="medium"
          class="basic-form"
        >
          <h2>Basic Info</h2>
          <el-form-item prop="account_type" label="Company / Individual">
            <el-select v-model="user_info.account_type" :disabled="!canEditCompanyName()">
              <el-option
                v-for="item in account_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="company" label="Fullname">
            <el-input v-model="user_info.company" :disabled="!canEditCompanyName()"></el-input>
          </el-form-item>

          <el-form-item prop="team_size" v-if="user_info.account_type == 0" label="Team Size">
            <el-select v-model="user_info.team_size" placeholder="The size of your team">
              <el-option
                v-for="item in team_size_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="team_size" v-if="user_info.account_type == 1" label="Company Size">
            <el-select v-model="user_info.team_size" placeholder="The size of your company">
              <el-option
                v-for="item in company_size_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="country" label="Country / Region">
            <el-select v-model="user_info.country" filterable>
              <el-option
                v-for="item in country"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
                <span style="float: left; color: #8492a6; font-size: 13px">
                  ({{ item.code }}){{ item.name }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="address" label="Address">
            <el-input name="address" type="text" v-model="user_info.address"></el-input>
          </el-form-item>

          <el-form-item prop="contact_name" label="Contact Name">
            <el-input name="contact_name" type="text" v-model="user_info.contact_name"></el-input>
          </el-form-item>

          <el-form-item prop="contact_number" label="Application Number">
            <el-input v-model="user_info.contact_number">
              <el-select
                v-model="user_info.contact_type"
                slot="prepend"
                popper-class="app-select"
                ref="contact_type"
              >
                <el-option
                  v-for="item in applications"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <img
                    :src="item.src"
                    style="width: 16px;height: 16px;margin-right: 16px;vertical-align: -3px;"
                  />
                  <span>{{ item.label }}</span>
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>

          <el-form-item label="Timezone" prop="timezone">
            <el-select v-model="user_info.timezone">
              <el-option
                v-for="item in timezone_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="payment-info">
      <el-col :span="12">
        <el-form
          ref="paymentForm"
          :model="payment"
          :rules="payment_rules"
          label-width="180px"
          label-position="right"
          size="medium"
          class="payment-form"
        >
          <h2>Payment Info</h2>
          <el-form-item label="Recipient Name">
            <el-input v-model="user_info.company" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item prop="pay_type" label="Payment Type">
            <el-select v-model="payment.pay_type">
              <el-option
                v-for="item in payment_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.id === 2"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            prop="account"
            :label="payment.pay_type === 1 ? 'Account Number' : 'Account'"
          >
            <el-input
              name="account"
              type="text"
              v-model="payment.account"
              v-if="payment.pay_type == 1"
            ></el-input>
            <el-input
              name="account"
              type="text"
              v-model="payment.account"
              v-if="payment.pay_type == 0 || payment.pay_type == 2"
              placeholder="Enter your Payoneer Number"
            ></el-input>
          </el-form-item>

          <el-form-item prop="currency" label="Currency" v-if="payment.pay_type === 1">
            <el-select v-model="payment.currency">
              <el-option :value="2" label="Dollar($)"></el-option>
              <el-option :value="1" label="RMB(￥)"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="country" label="Country / Region" v-if="payment.pay_type === 1">
            <el-select v-model="payment.country" filterable>
              <el-option
                v-for="item in country"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
                <span style="float: left; color: #8492a6; font-size: 13px">
                  ({{ item.code }}){{ item.name }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="bank_name" label="Bank Name" v-if="payment.pay_type === 1">
            <el-input name="bank_name" type="text" v-model="payment.bank_name"></el-input>
          </el-form-item>

          <el-form-item prop="bank_address" v-if="payment.pay_type === 1" label="Bank Address">
            <el-input name="bank_address" type="text" v-model="payment.bank_address"></el-input>
          </el-form-item>

          <el-form-item prop="bank_swift" v-if="payment.pay_type === 1" label="SWIFT CODE">
            <el-input name="bank_swift" type="text" v-model="payment.bank_swift"></el-input>
          </el-form-item>
          <el-form-item label="Signature" prop="signature">
            <el-upload
              action="/api/data/file/upload/"
              :auto-upload="true"
              class="avatar-uploader"
              :show-file-list="false"
              :on-change="uploadSign"
              :on-remove="removeSign"
              :on-success="handleSuccess"
              :on-exceed="uploadExceed"
              :file-list="fileList"
              :limit="1"
              accept=".jpg, .jpeg, .gif, .png"
              :data="{
                relative_s3_dir: 'download',
                if_hide: 0,
                if_remain_origin: 0,
                bucket: 'default',
                invalid_mime: ['text/plain'],
              }"
            >
              <img
                v-if="payment.signature && !sign_url"
                :src="payment.signature"
                class="sign-preview"
              />
              <img v-if="sign_url" :src="sign_url" class="sign-preview" />
              <i class="icon-y-add2"></i>
            </el-upload>
          </el-form-item>

          <div class="demo">
            <el-tooltip
              effect="light"
              placement="top"
              enterable
              :visible-arrow="false"
              popper-class="img-tooltip"
            >
              <div slot="content">
                <img src="../../assets/img/signature.png" class="sign-preview" />
              </div>
              <a>Example Of Signature</a>
            </el-tooltip>
          </div>

          <div class="note">
            <p>
              <i class="required-mark">*</i>
              Please Note:
            </p>
            <p>The signature supports jpg/png, white background, 180*100</p>
            <p>The signature is only used for invoice of your payment</p>
            <p>The signature must be consistent with the beneficiary's name</p>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-button @click="editUser" class="confirm-btn" type="primary">Confirm</el-button>
    </el-row>
  </el-card>
</template>

<script>
export default {
  name: 'personalInfo',
  data() {
    return {
      edit_loading: false,
      user_info: {
        contact_type: 0,
        pay_type: 1,
      },
      payment: {
        pay_type: 1,
        signature:'',
      },
      sign_url: '',
      account_type_list: this.registData.account_type,
      team_size_list: this.registData.team_size,
      company_size_list: this.registData.company_size,
      country: [],
      countrys: [],
      timezone_list: [],
      fileList: [],
      applications: [
        { label: 'Teams', value: 0, src: require('../../assets/img/Teams.png') },
        { label: 'QQ', value: 1, src: require('../../assets/img/QQ.png') },
        { label: 'WhatsApp', value: 2, src: require('../../assets/img/WhatsApp.png') },
        { label: 'LinkedIn', value: 3, src: require('../../assets/img/LinkedIn.png') },
        { label: 'Facebook', value: 5, src: require('../../assets/img/Facebook.png') },
        { label: 'Wechat', value: 6, src: require('../../assets/img/Wechat.png') },
      ],
      basic_rules: {
        account_type: [
          { required: true, message: 'Please select one item.', trigger: ['blur', 'change'] },
        ],
        company: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        team_size: [
          { required: true, message: 'Please select one item.', trigger: ['blur', 'change'] },
        ],
        country: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        address: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        contact_name: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        contact_number: [
          { required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] },
        ],
        contact_type: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        timezone: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
      },
      payment_rules: {
        pay_type: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        account: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        currency: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        country: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        bank_name: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        bank_address: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        bank_swift: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        // signature: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        signature: [
          // { required: true, message: 'Can not be empty.', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              value = this.payment.signature
              console.log(1,this.payment);
              console.log(2,this.user_info);
              if(!value){
                callback(new Error('Can\'t be empty!'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      },
      payment_list:[
        { id: 1, name: 'Bank'}
      ]
    }
  },
  created() {
    this.getUser()

    if (!this.countrys.length) {
      this.$http.get('/api/common/get-countries-r/', {}).then(data => {
        this.countrys = data.list
        // 用于注册页面的国家选择,去掉global选项
        this.country = this.countrys.slice(0, this.countrys.length - 1)
      })
    }

    if (!this.timezone_list.length) {
      this.$http.get('/api/common/get-tz-list-r/', {}).then(data => {
        let tzs = data.tzs
        for (let i = 0; i < tzs.length; i++) {
          tzs[i].name = tzs[i].gmt + ' ' + tzs[i].location
        }
        this.timezone_list = tzs
      })
    }
  },
  methods: {
    getUser() {
      this.$http.get('/accounts/').then(res => {
        this.user_info = JSON.parse(
          JSON.stringify(res, (key, value) => {
            if (key === 'payment') {
              return undefined
            } else {
              return value
            }
          })
        )
        if (this.user_info.team_size === 0) {
          this.user_info.team_size = ''
        }
        this.payment = res.payment
        if(this.payment){
          if(res.payment.pay_type === 2){
            let obj = { id:2 , name:'Payoneer' }
            this.payment_list.push(obj)
          }else{
            this.payment.pay_type = 1
          }
        }  
      })
    },
    handleSuccess(res, file, filelist) {
      if (res.c !== 0) {
        this.notifyOpen('Error', res.m, 'error')
        return
      }
      let v = file.response ? file.response.d : file
      this.payment.signature = v.s3_link
    },
    canEditCompanyName() {
      let { erp_status, status  } = this.user_info
      return (erp_status === 13 || erp_status === 0) && status === 3
    },
    canEditFullName() {
      return this.user_info.erp_status === 13 && this.user_info.is_approved === 0
    },
    editUser() {
      let p1 = new Promise((resolve, reject) => {
        this.$refs['basicForm'].validate(valid => {
          if (valid) {
            resolve()
          }
        })
      })
      let p2 = new Promise((resolve, reject) => {
        this.$refs['paymentForm'].validate(valid => {
          if (valid) {
            resolve()
          }
        })
      })
      Promise.all([p1, p2]).then(() => {
        this.edit_loading = true
        let params = {
          ...this.user_info,
          payment: JSON.stringify(this.payment),
        }
        this.$http
          .post('/accounts/modify-r/', params)
          .then(res => {
            this.edit_loading = false
            this.notifyOpen()
          })
          .catch(err => {
            this.edit_loading = false
            this.notifyOpen('Error', this.executeError(err), 'error')
          })
      })
    },
    uploadSign(file) {
      const isJPG = file.raw.type === 'image/jpg'
      const isJPEG = file.raw.type === 'image/jpeg'
      const isGIF = file.raw.type === 'image/gif'
      const isPNG = file.raw.type === 'image/png'
      const isLt3M = file.size / 1024 / 1024 < 3
      if (!isJPG && !isGIF && !isPNG && !isJPEG) {
        this.notifyOpen('Error', 'Please select an image to upload.', 'error')
        this.fileList = []
        this.user_info.signature = {}
        return
      }
      if (!isLt3M) {
        this.notifyOpen('Error', 'File size can not exceed 3m.', 'error')
        this.fileList = []
        this.user_info.signature = {}
        return
      }

      this.user_info.signature = file.raw
      this.sign_url = URL.createObjectURL(file.raw)
    },
    removeSign() {
      this.user_info.signature = {}
    },
    uploadExceed(file) {
      this.sign_url = URL.createObjectURL(file[0])
      this.user_info.signature = file[0]
    },
  },
}
</script>

<style lang="scss">
.personal-info {
  .el-input-group__prepend {
    .el-input {
      width: 142px;
    }
  }
  .confirm-btn {
    margin-top: 50px;
    margin-left: 180px;
    width: 300px;
    height: 48px;
    font-size: 24px;
    border-radius: 28px;
  }
  .basic-form,
  .payment-form {
    width: 650px;
  }
}
.payment-info {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 180px;
    height: 100px;
    .icon-y-add2 {
      font-size: 38px;
      line-height: 100px;
      color: #d9d9d9;
    }
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
    .icon-y-add2 {
      color: #409eff;
    }
  }
  .demo {
    margin-left: 180px;
    display: inline-flex;
    align-items: center;
  }
  .note {
    margin-left: 180px;
    margin-top: 20px;
    color: #9b9ea3;
    font-size: 12px;
    line-height: 18px;
  }
}
.sign-preview {
  width: 180px;
  height: 100px;
  border: 1px solid #eee;
}
.app-select {
  width: 143px;
}
</style>
